import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveWebstoreModal from '../../ResponsiveWebstoreModal';
import AppStack from '../../../../common/AppStack';
import AppText from '../../../../common/AppText';

const WsFinalSaleWarningInfoModal = ({
  mediaQueries,
  editModeEnabled,
  isOpen,
  onClose
}) => {
  const { isTabletOrSmaller } = mediaQueries;
  return (
    <ResponsiveWebstoreModal
      alignModal={isTabletOrSmaller ? 'end' : 'center'}
      editModeEnabled={editModeEnabled}
      isOpen={isOpen}
      mediaQueries={mediaQueries}
      onClose={onClose}
      radius={0}
      size={600}
      title="Final sale policy"
      trapFocus={false}
      zIndex={201}
    >
      <AppStack style={{ gap: 16 }}>
        <AppText style={{ fontSize: 16 }}>
          Items marked as Final Sale are not eligible for cancellation, return,
          exchange, or refund for any reason, except in the case of a
          manufacturing defect.
        </AppText>

        <AppText style={{ fontSize: 16 }}>
          If an item is final sale, this status will be clearly shown before
          purchase on the product page and during checkout. By completing your
          order, you acknowledge and agree to these terms.
        </AppText>
      </AppStack>
    </ResponsiveWebstoreModal>
  );
};

WsFinalSaleWarningInfoModal.propTypes = {
  editModeEnabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onClose: PropTypes.func
};

export default WsFinalSaleWarningInfoModal;
